export default {
  "buyingGuide.metaTitle": "Poradnik zakupowy USFans: jak przeglądać i kupować",
  "buyingGuide.metaDescription": "Prosty poradnik zakupowy USFans — przeglądaj kategorie produktów, zrozum, co sprawdzić, i przejdź do sklepu z pewnością.",
  "buyingGuide.badge": "Poradnik zakupowy",
  "buyingGuide.h1": "Twój poradnik zakupowy USFans",
  "buyingGuide.subtitle": "Szybki, przyjazny przegląd głównych kategorii produktów i tego, o czym pamiętać przed przejściem do sklepu.",
  "buyingGuide.intro": "Zakupy produktów USFans są łatwiejsze, gdy wiesz, gdzie patrzeć. Poniżej znajdziesz główne kategorie, prostą trzyetapową ścieżkę zakupów i odpowiedzi na najczęstsze pytania.",
  "buyingGuide.stepsTitle": "Jak robić zakupy w trzech krokach",
  "buyingGuide.step1.title": "Przeglądaj kategorię",
  "buyingGuide.step1.text": "Wybierz interesującą Cię kategorię produktów, aby zobaczyć dostępny asortyment.",
  "buyingGuide.step2.title": "Porównaj szczegóły",
  "buyingGuide.step2.text": "Sprawdź cenę, sprzedawcę i informacje o wysyłce, zanim podejmiesz decyzję.",
  "buyingGuide.step3.title": "Przejdź do sklepu",
  "buyingGuide.step3.text": "Gdy będziesz gotowy, otwórz sklep i dokończ zamówienie.",
  "buyingGuide.categoriesTitle": "Przeglądaj według kategorii",
  "buyingGuide.categoriesSubtitle": "Przejdź bezpośrednio do dowolnej kategorii produktów w sklepie.",
  "buyingGuide.storeTitle": "Gotowy na zakupy?",
  "buyingGuide.storeText": "Otwórz oficjalny sklep, aby przejrzeć pełną ofertę i złożyć zamówienie.",
  "buyingGuide.storeCta": "Odwiedź sklep",
  "buyingGuide.faqTitle": "Częste pytania",
  "buyingGuide.faq1.q": "Jak zacząć zakupy?",
  "buyingGuide.faq1.a": "Wybierz kategorię z powyższej listy lub przejdź bezpośrednio do sklepu, aby przejrzeć pełny asortyment.",
  "buyingGuide.faq2.q": "Co sprawdzić przed zakupem?",
  "buyingGuide.faq2.a": "Przejrzyj cenę, sprzedawcę i szczegóły wysyłki oraz potwierdź całkowity koszt przed dokończeniem zamówienia.",
  "buyingGuide.faq3.q": "Czy mogę później wrócić do tych poradników?",
  "buyingGuide.faq3.a": "Tak. Wróć do strony głównej w dowolnym momencie, aby przeglądać poradniki, porównania i wskazówki bezpieczeństwa obok kategorii produktów.",
  "buyingGuide.backHome": "Wróć do strony głównej",
};